export default __webpack_public_path__ + "static/media/mobile.7a7edb15.png";